// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function fullWidthSlides1_mouseIn(event, $w) {
	//Add your code for this event here: 
}

export function fullWidthSlides1_mouseIn_1(event, $w) {
	//Add your code for this event here: 
}

export function fullWidthSlides1_pause(event, $w) {
	//Add your code for this event here: 
}